import { useCallback } from 'react';
import { removeEmojis } from 'modules/codeless-events/utils/stringUtils';
import { STEP_IDS } from '../config/stepIds';
import { useConversionActions } from './useConversionActions';

export const useHandleButtonAnalyzerClick = ({
    setIsHighlighting,
    currentConversion,
    navigateToStepId,
    updateDraftEvent,
}) => {
    const { isEventNew } = useConversionActions();

    return useCallback(
        buttonData => {
            setIsHighlighting(false);

            if (currentConversion && buttonData && updateDraftEvent) {
                const eventId = currentConversion.id;
                const isNew = isEventNew(eventId);

                const newTrackedElements = [
                    {
                        ...(currentConversion.trackedElements?.[0] || {}),
                        selector: buttonData.path,
                        displayText: removeEmojis(buttonData.eventName),
                    },
                ];

                const updatePayload = {
                    trackedElements: newTrackedElements,
                    conversionName: removeEmojis(buttonData.eventName),
                };

                if (isNew) {
                    updatePayload.eventName = removeEmojis(buttonData.eventName);
                }

                updateDraftEvent(draft => ({
                    ...draft,
                    ...updatePayload,
                }));
            }
            if (navigateToStepId) {
                navigateToStepId(STEP_IDS.SETUP_CLICKS_EVENT_CATEGORY);
            }
        },
        [currentConversion, setIsHighlighting, updateDraftEvent, navigateToStepId, isEventNew]
    );
};
